import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import { DynamicObject } from 'src/utils/commonTypes';

import generateSubscriptionBannerRequestObj from './SubscriptionBannerHandler';
import { FETCH_SUBSCRIPTION_BANNER_QUERY } from '../../GraphQL/Queries/SubscriptionBannerQuery';
import { graphQlRequest } from '../../GraphQL/RequestHandler';
import {
  BannerAPIContentType,
  BannerAPIResponseType
} from '../../responseTypes/BannerApiResponse';

export const fetchSubscriptionBannerImages = async (
  header: string[]
): Promise<BannerAPIResponseType[] | unknown> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_SUBSCRIPTION_BANNER_QUERY,
      generateSubscriptionBannerRequestObj(),
      GQL_QUERIES.FETCH_SUBSCRIPTION_BANNER_QUERY,
      header
    );
    if (
      Object.keys(response).length > 0 &&
      // eslint-disable-next-line no-prototype-builtins
      response.hasOwnProperty('collection')
    ) {
      return response.collection.rails[0].contents.filter(
        (bannerImage: BannerAPIContentType) =>
          Object.keys(bannerImage).length > 0
      );
    }
    return {};
  } catch (error) {
    console.error('Error while fetching movie by id: ', error);
    return {};
  }
};
